var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1513_24626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37976 5.51811L0.692805 6.20143L0.00585938 5.51811L0.692805 4.83478L1.37976 5.51811ZM17.8952 13.2491C17.8952 13.7828 17.4603 14.2154 16.9237 14.2154C16.3871 14.2154 15.9522 13.7828 15.9522 13.2491H17.8952ZM5.55029 11.0333L0.692805 6.20143L2.06671 4.83478L6.9242 9.66665L5.55029 11.0333ZM0.692805 4.83478L5.55029 0.00292969L6.9242 1.36959L2.06671 6.20143L0.692805 4.83478ZM1.37976 4.55174H11.0947V6.48448H1.37976V4.55174ZM17.8952 11.3163V13.2491H15.9522V11.3163H17.8952ZM11.0947 4.55174C14.8505 4.55174 17.8952 7.58035 17.8952 11.3163H15.9522C15.9522 8.6478 13.7774 6.48448 11.0947 6.48448V4.55174Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1513_24626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.895,
    height: 14.2346,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.acb61af392335a9abf2d0afb3a051528.svg";
export { ForwardRef as ReactComponent };